import _ from "lodash";

class ProductBuilder {
    generateProducts(catalogs: any[], items: any[], subitems: any[], tags: any[]) {
        let _cats = filterActiveAndSortRow(catalogs)
        let _items = filterActiveAndSortRow(items)
        let _subitems = filterActiveAndSortRow(subitems)

        //reduce tags to key itemId and value tag-string Array
        const tagHolder = _.reduce(tags, (result, value, key) => {
            (result[value.ItemId] || (result[value.ItemId] = [])).push(value.Tag);
            return result;
        }, {});




        //group items by catalog
        let itemMap = _.groupBy(_items, 'CatalogId')

        //group subitems by item
        let subitemMap = _.groupBy(_subitems, 'ItemId')

        //merge all
        for (let i = 0; i < _cats.length; i++) {
            let cat = _cats[i]
            let _i = _.orderBy(itemMap[cat.Id], 'Row')
            cat.Items = _i
            removeFields(cat)
            for (let j = 0; j < cat.Items.length; j++) {
                let item = cat.Items[j]
                removeFields(item)

                //add tags
                if (tagHolder[item.Id]) {
                    item.Tags = tagHolder[item.Id] || []
                }

                let _s = _.orderBy(subitemMap[item.Id], 'Row')
                item.SubItems = _s
                for (let k = 0; k < item.SubItems.length; k++) {
                    let subitem = item.SubItems[k]
                    removeFields(subitem)
                }
            }
        }

        return _cats

    }

    generateToppingGroups(toppinggroups: any[], toppings: any[]) {

        //group toppings by toppinggroup
        let toppingGroupMap = {}
        for (let i = 0; i < toppings.length; i++) {
            let topping = toppings[i]
            if (!toppingGroupMap[topping.GroupId]) {
                toppingGroupMap[topping.GroupId] = []
            }
            toppingGroupMap[topping.GroupId].push(topping)
        }

        //merge toppinggroup with toppings
        for (let i = 0; i < toppinggroups.length; i++) {
            let toppinggroup = toppinggroups[i]
            let _t = _.orderBy(toppingGroupMap[toppinggroup.Id], 'Row')
            toppinggroup.Toppings = _t
        }

        let _group = _.orderBy(toppinggroups, 'Row')

        return _group
    }


}

export default ProductBuilder;



function filterActiveAndSortRow(list) {
    let _list = _.orderBy(list, 'Row')
    return _list
}


const FILEDS = ['CustomerId', "IsHide", "Amount", "Quantity", "Percent", "IsDeleted", "Tags", "DiscountedPrice"]
function removeFields(itemLine) {

    for (let i = 0; i < FILEDS.length; i++) {
        let field = FILEDS[i]
        delete itemLine[field]
    }
    return itemLine
}